import React, { useState, useEffect, useCallback } from "react";
import { ImageSelector, StatusLabel } from "../../CoreUI";
import {
	ProductViewExpandableCard,
	ProductViewRoundedCard,
} from "../ProductViewCore";
import useTrack, { eventTypes } from "../../../hooks/useTrack";
import { FaChevronDown as DownArrow } from "react-icons/fa";

import "./product-view-basic-card.css";

const ProductViewBasicCard = React.memo(
	({
		product,
		productViewEventProps,
		setActiveImage,
		error,
		navToTop,
		extraPadding = false,
	}) => {
		if (!product) {
			return;
		}
		const [imgArray, setImgArray] = useState([]);
		const [imgSelected, setImgSelected] = useState(0);
		const [showBtn, setShowBtn] = useState(true);

		const track = useTrack();

		useEffect(() => {
			const { image_key, photo_url, supplementary_images } = product;
			let _imgArray = [
				{
					image_key,
					photo_url,
				},
			];
			if (supplementary_images) {
				_imgArray = _imgArray.concat(supplementary_images);
			}
			setActiveImage(_imgArray[0]);
			setImgSelected(0);
			setImgArray(_imgArray);
		}, [product, setActiveImage]);

		const handleImgChange = useCallback(
			(activeImg, selected) => {
				setActiveImage(activeImg);
				setImgSelected(selected);
				track(eventTypes.WIDGET_PDP_IMAGE_CLICK, {
					...productViewEventProps,
					imageUrlInfo: JSON.stringify(activeImg),
					imgArrayIndex: selected,
				});
			},
			[track, setActiveImage, productViewEventProps]
		);

		const onExpand = useCallback(() => {
			track(eventTypes.WIDGET_PDP_PRODUCT_DETAIL_CLICK, {
				...productViewEventProps,
				short_product_description:
					product?.description?.length < 68 || false,
			});
			if (product?.description?.length > 68) {
				navToTop();
			}
		}, [navToTop, track, product, productViewEventProps]);

		const handleButtonClick = useCallback(() => {
			navToTop();
		}, [navToTop]);

		useEffect(() => {
			if (extraPadding) {
				setShowBtn(true);
			} else {
				setShowBtn(false);
			}
		}, [extraPadding]);

		return (
			<ProductViewRoundedCard
				className="product-view-basic-card"
				style={extraPadding ? { paddingBottom: "200px" } : {}}
			>
				<ImageSelector
					imgArray={imgArray}
					selected={imgSelected}
					onChange={handleImgChange}
				/>
				<h1 className="product-view-basic-title">
					{product.name || ""}
				</h1>
				<div className="product-view-basic-price">
					${product.discounted_price || product.price}
				</div>
				{error && <StatusLabel>{error}</StatusLabel>}
				{product?.description?.length > 0 && (
					<ProductViewExpandableCard
						expandOpenFooter={
							extraPadding
								? "Scroll down to learn more"
								: "Read More about the product"
						}
						triggerExpand={
							product?.description?.length < 68 || false
						}
						onExpand={onExpand}
						className="product-view-basic-description"
					>
						<div
							dangerouslySetInnerHTML={{
								__html: product.description,
							}}
						/>
					</ProductViewExpandableCard>
				)}

				{showBtn && (
					<div
						className="product-view-basic-expand-footer-btn"
						onClick={handleButtonClick}
					>
						<DownArrow />
					</div>
				)}
			</ProductViewRoundedCard>
		);
	}
);

export default ProductViewBasicCard;
